<template>
  <div>
    <div class="more-cohorts clickable" @click="$emit('click', $event)">
      <div class="no-show overflow-hidden">
        <span class="countspan break-all">Showing {{ count }} of {{ totalCount }} </span>
      </div>
      <div class="show-more">Show More <v-icon>mdi-menu-down</v-icon></div>
      <div>
        <span class="countspan">Showing {{ count }} of {{ totalCount }} </span>
      </div>
    </div>
    <div class="position-relative mt-4">
      <LoaderLinear v-if="isLoading" />
    </div>
  </div>
</template>

<script>
import LoaderLinear from '../common/loader/LoaderLinear.vue'
export default {
  components: { LoaderLinear },
  props: ['count', 'totalCount', 'isLoading'],
}
</script>

<style lang="scss" scoped>
.more-cohorts {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  padding: 8px;
  background-color: #e6f6f8;
  font-size: 15px;

  .countspan {
    color: #8c9093;
    float: right;
    white-space: nowrap;

    &.break-all {
      word-break: break-all;
    }
  }
  .show-more {
    display: flex;
    align-items: center;
    color: #8c9093;
    font-weight: bold;
    white-space: nowrap;
  }
}
</style>